"use strict";
/*
 * Created on 2019-04-11
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PartialDataObjectConverter_1 = require("../../../core/conversions/PartialDataObjectConverter");
/**
 * @author JMr
 */


var SelloutImpactRecordConverter =
/*#__PURE__*/
function (_PartialDataObjectCon) {
  _inherits(SelloutImpactRecordConverter, _PartialDataObjectCon);

  function SelloutImpactRecordConverter() {
    _classCallCheck(this, SelloutImpactRecordConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactRecordConverter).apply(this, arguments));
  }

  return SelloutImpactRecordConverter;
}(PartialDataObjectConverter_1.PartialDataObjectConverter);

exports.SelloutImpactRecordConverter = SelloutImpactRecordConverter;